module.exports = __webpack_public_path__ + "img/sys9.64a07e31.png";